import React from 'react';
import type { MembershipBannerProps } from '@noths/polaris-client-ribbons-design-system';
import { MembershipBanner } from '@noths/polaris-client-ribbons-design-system';

import type { MembershipBannerLocation } from 'src/tracking/events/membershipBannerEvents';
import { trackImpression, trackLinkClick } from 'src/tracking/events/membershipBannerEvents';
import * as styles from './MembershipBannerSection.styles';

const DEFAULT_HEADING = 'Get 10% off any of these amazing finds';
const DEFAULT_COPY =
  'Join NOTHS & More for 10% off everything for a year – including sale and all your Christmas shopping!';
const DEFAULT_BUTTON_TEXT = 'Tell me more';
const DEFAULT_BUTTON_HREF = '/membership';
const DEFAULT_BACKGROUND_IMAGE_URL =
  'https://images.contentstack.io/v3/assets/blt63f2f7afd19b09c2/bltda8db62750e92379/68e3aae4b0493ac06bccdec9/noths-more-banner.jpg';

interface MembershipBannerSectionProps extends Partial<MembershipBannerProps> {
  trackingLocation: MembershipBannerLocation;
}

export const MembershipBannerSection = ({
  backgroundImageUrl = DEFAULT_BACKGROUND_IMAGE_URL,
  buttonHref = DEFAULT_BUTTON_HREF,
  buttonText = DEFAULT_BUTTON_TEXT,
  copy = DEFAULT_COPY,
  heading = DEFAULT_HEADING,
  trackingLocation,
}: MembershipBannerSectionProps) => {
  const trackingArgs = {
    contentType: 'membership banner|plp-membership-banner-noths&more',
    label: 'plp-membership-banner-noths&more',
    location: trackingLocation,
  };

  return (
    <div css={styles.wrapper}>
      <MembershipBanner
        backgroundImageUrl={backgroundImageUrl}
        buttonHref={buttonHref}
        buttonText={buttonText}
        copy={copy}
        heading={heading}
        onButtonClick={(e) => trackLinkClick(e, trackingArgs)}
        onVisible={() => trackImpression(trackingArgs)}
      />
    </div>
  );
};
